import { CreateQuestions } from "../../quiz-zone/create-questions";

const CreateContestQuestion = () => (
	<CreateQuestions type="contest" title={"Contest"} subTitle="Contest" />
);

export default CreateContestQuestion;
